import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types';
import './com-checkbox.less'

/*
 * props参数
 * checked: 是否选中
 * checkType: 是否全选了  none:没有  part:选择了一部分  all:全选了
 * row: 当前行数据
 * isRow: 是否表格中的多选框
 * change: 值改变时触发的父级传过来的方法
 */

const ComCheckbox = (props) => {

  const checkedChange = () => {
    props.change && props.change(!props.checked, props.row);
  }

  return (
    <div className={`com-checkbox-wrap ${props.isRow ? 'com-td-checkbox-wrap' : ''}`} onClick={checkedChange}>
      <div className={`com-checkbox-inner ${props.checked||props.checkType=='all'?'com-is-checked':''} ${props.checkType=='part'?'com-is-indeterminate':''}`}></div>
    </div>
  )
}

ComCheckbox.propTypes = {
  checked: PropTypes.bool,
  checkType: PropTypes.string,
  row: PropTypes.object,
  isRow: PropTypes.bool
}

export default withRouter(ComCheckbox);